import Main from '../../../layouts/Main.vue';
import Home from '../views/Home.vue';

export default [
  {
    path: '/',
    name: 'pagesModule',
    component: Main,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        title: 'TalentSensus',
        icon: 'fa-users',
        meta: {
          allowGuest: true,
        },
      }
    ]
  }
];